import { getPeriods } from "./utils"

export function calculatePoints(data) {
    const howMuchDays = data["1"]
    const { values, multiplier } = data["3"]
    const { currentChart } = data["4"]
    const roomType = data["5"].column
    const periods = getPeriods(values, currentChart.periods)
    let points = 100

    let cycleResult = 0
    try {
        while (points < 2000 && cycleResult < howMuchDays) {
            cycleResult = 0
            periods.forEach((period) => {
                const { minDays, maxDays } = calculate(currentChart, points, period.group, roomType)
                if (multiplier) {
                    cycleResult += minDays
                } else {
                    cycleResult += maxDays
                }
            })
            cycleResult = cycleResult / periods.length
            points += 5
        }
    } catch (err) {
        console.log("err", err)
    }

    return points
}

const calculate = (selectedChart, points, period, column) => {
    const header = selectedChart.headers.find((i) => i.column === column)
    const columnsAvailable = [1, 2, 3, 4, 5].filter((i) => header["points_" + i])
    let minDays
    let maxDays
    selectedChart.rows
        .filter((i) => i.period === period)
        .forEach((row) => {
            if (row.nights === "WEEKLY") {
                return
            }
            row.cells.forEach((cell) => {
                if (cell.column === header.column) {
                    columnsAvailable.forEach((coll) => {
                        const key = "points_" + coll
                        const value = cell[key]
                        const days = points / value
                        if (days > 0) {
                            if (days > 1) {
                                minDays = minDays ? Math.min(days, minDays) : days
                            }
                            maxDays = maxDays ? Math.max(days, maxDays) : days
                        }
                    })
                }
            })
        })
    return {
        minDays: maxDays ? Math.floor(minDays) : 0,
        maxDays: maxDays ? Math.floor(maxDays) : 0
    }
}
